// src/App.tsx
import { Providers } from "./providers/providers";
import { WidgetPage } from "./widget-page";
import { parseWidgetConfig } from "../widget-config";
import { pickWidgetLocale } from "@studiolite/booking";
import { isMaintenanceMode, MaintenancePage } from "./maintenance-page";

function App() {
  // Passe par le schema partage plutot que de relire le parametre a la main :
  // c'est lui qui decrit ce que `embed.js` envoie, et il porte le defaut.
  const parsed = parseWidgetConfig(window.location.search);
  // Une URL malformee ne doit pas laisser une page blanche sur le site d'un
  // studio : on retombe sur le francais et on laisse le widget se debrouiller
  // avec ce qu'il trouve.
  // Sans data-locale, WidgetPage passe a la langue du studio une fois celui-ci
  // charge ; d'ici la, le francais.
  // En attendant le studio : data-locale, sinon la langue de la page.
  const requested = parsed.ok ? parsed.config.locale : undefined;
  const page = parsed.ok ? parsed.config.pageLocale : undefined;
  const locale = pickWidgetLocale({ snippet: requested, page });

  if (isMaintenanceMode()) {
    return <MaintenancePage locale={locale} />;
  }

  return (
    <Providers locale={locale}>
      <WidgetPage />
    </Providers>
  );
}

export default App;
